export class Settings
{
    public name: string;
    public loadingSpinner: boolean;
    public fixedHeader: boolean;
    public fixedSidenav: boolean;
    public fixedSidenavUserContent: boolean;
    public fixedFooter: boolean;
    public sidenavIsOpened: boolean;
    public sidenavIsPinned: boolean;
    public menu: string;
    public menuType: string;
    public theme: string;
    public rtl: boolean;

    constructor(settings: Partial<Settings> = {})
    {
        this.name = settings.name ?? "";
        this.loadingSpinner = settings.loadingSpinner ?? true;
        this.fixedHeader = settings.fixedHeader ?? true;
        this.fixedSidenav = settings.fixedSidenav ?? true;
        this.fixedSidenavUserContent = settings.fixedSidenavUserContent ?? false;
        this.fixedFooter = settings.fixedFooter ?? false;
        this.sidenavIsOpened = settings.sidenavIsOpened ?? true;
        this.sidenavIsPinned = settings.sidenavIsPinned ?? true;
        this.menu = settings.menu ?? "vertical";
        this.menuType = settings.menuType ?? "default";
        this.theme = settings.theme ?? "teal-light";
        this.rtl = settings.rtl ?? false;
    }
}
